export const BSC_TESTNET_TOKEN_LIST = {
  name: 'KyberSwap Token List',
  keywords: ['kyberswap', 'dmmexchange'],
  timestamp: '2020-12-12T00:00:00+00:00',
  tokens: [
    {
      chainId: 97,
      address: '0x51E8D106C646cA58Caf32A47812e95887C071a62',
      symbol: 'KNC',
      name: 'Kyber Network Crystal',
      decimals: 18,
    },
    {
      chainId: 97,
      address: '0xb448B701807E644f141a4E4a269aD2F567526505',
      symbol: 'USDC',
      name: 'USDC',
      decimals: 6,
    },
    {
      chainId: 97,
      address: '0x3d8f2Ada8e97e4eF19e4ccBf6ec1Ca52900406aA',
      symbol: 'USDT',
      name: 'USDT',
      decimals: 6,
    },
    {
      chainId: 97,
      address: '0xBb843a2296F9AA49070EB2Dcd482f23548238f65',
      symbol: 'DAI',
      name: 'DAI',
      decimals: 18,
    },
    {
      chainId: 97,
      address: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
      symbol: 'WBNB',
      name: 'Wrapped BNB',
      decimals: 18,
    },
  ],
  version: {
    major: 0,
    minor: 0,
    patch: 0,
  },
}
